import { AxisBottom, AxisLeft } from '@visx/axis'
import { Group } from '@visx/group'
import { scaleLinear } from '@visx/scale'
import { LinePath } from '@visx/shape'
import { ParentSize } from '@visx/responsive'

export default function StrategyResultsGraphBalance({ data }) {

    if (data.length === 0) {
        return
    }

    const margin = { top: 40, right: 20, bottom: 50, left: 60 }

    const xAccessor = d => d.id
    const yAccessor = d => parseFloat(d.balance)

    const minId = data[0].id
    const maxId = data[data.length - 1].id

    let maxBalance = -Infinity
    let minBalance = Infinity

    for (let i = 0; i < data.length; i++) {
        const currentBalance = parseFloat(data[i].balance)
        if (currentBalance > maxBalance) {
            maxBalance = currentBalance
        }
        if (currentBalance < minBalance) {
            minBalance = currentBalance
        }
    }

    return (
        <ParentSize>
            {({ width }) => {

                const height = 400

                const xScale = scaleLinear({
                    domain: [minId, maxId],
                    range: [0, width - margin.left - margin.right]
                })

                const yScale = scaleLinear({
                    domain: [minBalance, maxBalance],
                    nice: true,
                    range: [height - margin.top - margin.bottom, 0]
                })

                return (
                    <svg width={width} height={height}>
                        <Group left={margin.left} top={margin.top}>
                            <LinePath
                                data={data}
                                x={d => xScale(xAccessor(d))}
                                y={d => yScale(yAccessor(d))}
                                stroke="#007bff"
                                strokeWidth={1}
                                curve={null}
                            />

                            <AxisLeft
                                scale={yScale}
                                tickFormat={value => value.toFixed(0)}
                                label="Balance"
                                stroke="#000"
                                tickStroke="#000"
                                tickLabelProps={() => ({
                                    fill: 'var(--graph-label)',
                                    fontSize: 11,
                                    textAnchor: 'end',
                                    dx: '-0.25em',
                                    dy: '0.25em'
                                })}
                            />

                            <AxisBottom
                                top={height - margin.top - margin.bottom}
                                scale={xScale}
                                label={null}
                                stroke="#000"
                                tickStroke="#000"
                                numTicks={width > 520 ? 10 : width > 320 ? 5 : 3}
                                tickLabelProps={() => ({
                                    fill: 'var(--graph-label)',
                                    fontSize: 11,
                                    textAnchor: 'middle'
                                })}
                            />
                        </Group>
                    </svg>

                )
            }}
        </ParentSize>
    )


}

